import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Remove, Cookie } from "../shared/icons";

const CookieWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 382px;
  background: #fff;
  border: 1px solid #091C0033;
  color: #333;
  border-radius: 0 0 12px 0;
  padding: 16px 18px 16px 24px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.3s ease-in-out;
  font-family: "Manrope", sans-serif;
  @media (max-width: 768px) {
    width: 90%;
    bottom: 10px;
    right: 5%;
  }
`;

const Header = styled.div`
  font-family: Manrope;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;

`;

const Text = styled.p`
  font-family: Manrope;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0%;
  margin-inline: 0;
  margin-block: 10px;
  line-height: 24px;
  letter-spacing: 0%;
`;

const PrivacyLink = styled.a`
  color: #FF9D59;
  text-decoration: underline;
`;

const Button = styled.button`
  background: #FF9D59;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
  width: 200px;
  height: 41px;
  border: 0;
  gap: 10px;
  border-radius: 80px;
  padding-top: 8px;
  padding-right: 20px;
  padding-bottom: 8px;
  padding-left: 20px;
  font-family: Manrope;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -0.9px;
  text-align: center;
  &:hover {
    background: #ff8c4a;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled.div`
display: flex;
justify-content: space-between;
`

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <CookieWrapper>
      <Container>
        
        
        <HeaderContainer>
        <Header>We use cookies.</Header>
        <CloseButton onClick={() => setVisible(false)} aria-label="Close">
          <Remove  height="20" width="20"/>
        </CloseButton>
        </HeaderContainer>
        <Text>
          Our website uses cookies.
          <br/>
          By continuing to use our website, you agree to our {" "}
          <PrivacyLink href="/privacypolicy">privacy policy.</PrivacyLink>
        </Text>
        <Button onClick={handleAccept}>Accept cookies<img src={Cookie}/></Button>
      </Container>
    </CookieWrapper>
  );
};

export default CookieConsent;
